import React, { useEffect, useState } from 'react';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Nav, NavItem, NavLink } from 'reactstrap';

// Components
import DadosFiscalicazao from './DadosFiscalicazao';
import DadosDenunciante from './DadosDenunciante';
import MainCard from '../../../../components/MainCard';

//Helpers
import { showMessage } from '../../../../helpers/message';

//Context
import { useAuth } from '../../../../context/auth';
import solicitacaoFiscalizacao_api from '../../../../api/solicitacaoFiscalizacao_api';
import { useLocation, useNavigate } from 'react-router-dom';

function initialStateSolicitacaoFiscalicazao() {
    return {
        tipoFiscalizacao_id: "",
        protocolo: "",
        origem: "Interna",
        permitiExecucao: "true",
        cep: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        uf: "",
        latitude: "",
        longitude: "",
        tipoFiscalizacaoServico_Id: "",
        contatoDenuncia_Nome: "",
        contatoDenuncia_Telefone: "",
        contatoDenuncia_Email: "",
        contatoDenuncia_CPF: "",
        observacoes: "",
        codigoItemFiscalizado: null,
        entidadeFiscalizada: null,
        situacao: "Pendente",
        anexos: []
    }
}

function SolicitacaoFiscalizacaoStepper() {
    //Estado de controle do passo ativo
    const [activeStep, setActiveStep] = useState(1);

    const navigate = useNavigate();

    //Controle dos dados que vem na rota
    const location = useLocation();

    //Filtros que vem da location
    const { id, filtros, btnVoltar } = location.state ? location.state : {};

    //State para criar/editar solicitação fiscalização
    const [solicitacaoFiscalicao, setSolicitacaoFiscalicao] = useState(initialStateSolicitacaoFiscalicazao());

    //Estado de controle do loading da solicitacao
    const [loadingSolicitacao, setLoadingSolicitacao] = useState(false);

    const { setLoading } = useAuth();

    const loadSolicitacaoFiscalizacao = (id) => {
        if (id != null || solicitacaoFiscalicao.id != null) {
            setLoading(true);
            setLoadingSolicitacao(true);
            solicitacaoFiscalizacao_api.getItem(id ?? solicitacaoFiscalicao?.id).then(response => {
                response.data.tipoFiscalizacaoServico_Id = response.data.tipoFiscalizacaoServico_Id.toString();
                response.data.coordenadas = [parseFloat(response.data.latitude), parseFloat(response.data.longitude)];
                setSolicitacaoFiscalicao(response.data)
            })
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(() => {
                    setLoadingSolicitacao(false);
                    setLoading(false)
                });
        }
    }

    useEffect(() => {
        loadSolicitacaoFiscalizacao(id);
    }, [id]);

    //Função que retorna o valor do passo ativo
    const getContent = () => {
        switch (activeStep) {
            case 1:
                return <DadosFiscalicazao
                    id={id}
                    solicitacaoFiscalicao={solicitacaoFiscalicao}
                    setSolicitacaoFiscalicao={setSolicitacaoFiscalicao}
                    loadSolicitacaoFiscalizacao={loadSolicitacaoFiscalizacao}
                />
            case 2:
                return <DadosDenunciante
                    solicitacaoFiscalicao={solicitacaoFiscalicao}
                    setSolicitacaoFiscalicao={setSolicitacaoFiscalicao}
                    loadSolicitacaoFiscalizacao={loadSolicitacaoFiscalizacao}
                />
        }
    }
    return <>
        <Button
            onClick={() => {
                if (btnVoltar) {
                    navigate(btnVoltar, { state: { filtros: filtros, ...location.state } });
                } else {
                    navigate(-1);
                }
            }}
            className='px-4'
        >
            <FontAwesomeIcon icon={faAngleLeft} className='me-2' />
            Voltar
        </Button>
        <MainCard>
            <h5 style={{ color: "#666" }}>Cadastro Demanda</h5>
            <Nav tabs>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 1 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 1 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => { setActiveStep(1); }}
                    >
                        Dados da Fiscalização
                    </NavLink>
                </NavItem>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 2 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 2 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => {
                            if (!solicitacaoFiscalicao.id) {
                                showMessage("Aviso", "É necessário salvar os dados da fiscalização antes de ir para próximo step.", "error", null)
                                return;
                            }
                            setActiveStep(2);
                        }}
                    >
                        Dados do Denunciante
                    </NavLink>
                </NavItem>
            </Nav>
            <div className="mt-4">
                {((id && solicitacaoFiscalicao.id && !loadingSolicitacao) || id == null) && getContent()}
            </div>
        </MainCard>
    </>;
}

export default SolicitacaoFiscalizacaoStepper;